var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTradeTrust(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1276 4.65444C11.8651 4.65444 12.463 4.06022 12.463 3.32722C12.463 2.59422 11.8651 2 11.1276 2C10.3901 2 9.79224 2.59422 9.79224 3.32722C9.79224 4.06022 10.3901 4.65444 11.1276 4.65444Z",
    fill: "#EF7D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77287 11.1759C5.752 11.1759 6.54574 10.3871 6.54574 9.41391C6.54574 8.44081 5.752 7.65192 4.77287 7.65192C3.79374 7.65192 3 8.44081 3 9.41391C3 10.3871 3.79374 11.1759 4.77287 11.1759Z",
    fill: "#2660A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7692 16.5076C10.7484 16.5076 11.5421 15.7187 11.5421 14.7456C11.5421 13.7725 10.7484 12.9836 9.7692 12.9836C8.79009 12.9836 7.99634 13.7725 7.99634 14.7456C7.99634 15.7187 8.79009 16.5076 9.7692 16.5076Z",
    fill: "#2660A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9496 4.47137C15.6363 4.47137 16.1929 3.91814 16.1929 3.23569C16.1929 2.55324 15.6363 2 14.9496 2C14.2629 2 13.7063 2.55324 13.7063 3.23569C13.7063 3.91814 14.2629 4.47137 14.9496 4.47137Z",
    fill: "#EF7D00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9098 4.47137C19.5965 4.47137 20.1531 3.91814 20.1531 3.23569C20.1531 2.55324 19.5965 2 18.9098 2C18.2231 2 17.6665 2.55324 17.6665 3.23569C17.6665 3.91814 18.2231 4.47137 18.9098 4.47137Z",
    fill: "#EF7D00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9496 13.5559C15.6363 13.5559 16.1929 13.0026 16.1929 12.3202C16.1929 11.6378 15.6363 11.0845 14.9496 11.0845C14.2629 11.0845 13.7063 11.6378 13.7063 12.3202C13.7063 13.0026 14.2629 13.5559 14.9496 13.5559Z",
    fill: "#EF7D00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79222 22C10.7841 22 11.5881 21.2008 11.5881 20.2151C11.5881 19.2293 10.7841 18.4302 9.79222 18.4302C8.8004 18.4302 7.99634 19.2293 7.99634 20.2151C7.99634 21.2008 8.8004 22 9.79222 22Z",
    fill: "#2660A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1238 7.21739C15.8705 6.62241 15.2259 6.30204 14.6042 6.48511C14.1668 6.62241 13.8444 6.96566 13.7523 7.40045C13.7062 7.56063 13.6142 7.69794 13.4991 7.81232C12.7853 8.31574 11.8873 8.40729 11.0815 8.08693C10.9434 8.04118 10.7822 7.9725 10.644 7.88099C10.5749 7.83519 10.4829 7.81232 10.4138 7.76656L10.3678 7.76656C9.97632 7.60638 9.53887 7.60638 9.12445 7.76656C8.20346 8.13268 7.766 9.13957 8.11136 10.0549C8.45675 10.9244 9.42374 11.3821 10.3217 11.0846C10.6901 10.9702 11.0124 10.7185 11.2196 10.3981C11.2657 10.3295 11.3117 10.2379 11.3578 10.1693C11.3578 10.1693 12.486 8.29286 13.9135 8.52172C14.0286 8.56747 14.1437 8.61322 14.2589 8.6819C14.5812 8.91071 14.9726 8.95646 15.341 8.84208C15.9857 8.6361 16.354 7.92675 16.1469 7.28602C16.1238 7.26314 16.1238 7.24027 16.1238 7.21739Z",
    fill: "url(#paint0_linear_439_10858)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_439_10858",
    x1: 9.95289,
    y1: 10.5601,
    x2: 15.5213,
    y2: 4.95503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2660A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#3061A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#4A658A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#756B66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#AF7436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7D00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeTrust);
export default __webpack_public_path__ + "static/media/trade-trust.02d2825a8390f8ad658e5b1a0a6a4fb3.svg";
export { ForwardRef as ReactComponent };